// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout grid for the section-arranged record pages -- Person and Laboratory,
   Display and Editor alike. Person and Laboratory each carried a byte-identical
   copy of these rules under its own prefix; this is that shared copy.

   The per-section \`grid-column\` is applied inline from the saved layout; here we
   set the shared grid track and the responsive collapse. Biblio still has its
   own copy under .biblio-editor-* names.

   Mirrors biblioEditorSections.css. */

.section-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 1rem;
  row-gap: 0.5rem;
  grid-auto-flow: row dense;
  align-items: start;
}

.section-grid__item {
  min-width: 0; /* allow field rows to shrink/reflow in narrow columns */
}

/* Side-by-side arrangement: switch to a full-width (fluid) container so columns
   get real estate instead of being squished inside the capped container. Each of
   the 12 tracks has a minimum width (supplied per-arrangement via the
   --section-col-floor custom property), so a section's minimum scales with its
   span. We intentionally do NOT use overflow-x:auto on the grid -- that would clip
   inline dropdown menus -- and let the browser scroll the page instead. */
.section-grid--wide {
  grid-template-columns: repeat(12, minmax(var(--section-col-floor, 120px), 1fr));
}

/* Bootstrap field rows carry negative gutters that can spill past a bare
   container; mirror a column's 15px padding on each side-by-side section so those
   gutters are absorbed within the section instead of overflowing the grid. */
.section-grid--wide .section-grid__item {
  padding-left: 15px;
  padding-right: 15px;
}

/* On narrow screens, drop the grid and stack sections full-width in source order
   so labels/inputs stay readable. */
@media (max-width: 768px) {
  .section-grid {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sectionGrid.css"],"names":[],"mappings":"AAAA;;;;;;;;sCAQsC;;AAEtC;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,wDAAwD;AACxE;;AAEA;;;;;0EAK0E;AAC1E;EACE,+EAA+E;AACjF;;AAEA;;6EAE6E;AAC7E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;oCACoC;AACpC;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Layout grid for the section-arranged record pages -- Person and Laboratory,\n   Display and Editor alike. Person and Laboratory each carried a byte-identical\n   copy of these rules under its own prefix; this is that shared copy.\n\n   The per-section `grid-column` is applied inline from the saved layout; here we\n   set the shared grid track and the responsive collapse. Biblio still has its\n   own copy under .biblio-editor-* names.\n\n   Mirrors biblioEditorSections.css. */\n\n.section-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  column-gap: 1rem;\n  row-gap: 0.5rem;\n  grid-auto-flow: row dense;\n  align-items: start;\n}\n\n.section-grid__item {\n  min-width: 0; /* allow field rows to shrink/reflow in narrow columns */\n}\n\n/* Side-by-side arrangement: switch to a full-width (fluid) container so columns\n   get real estate instead of being squished inside the capped container. Each of\n   the 12 tracks has a minimum width (supplied per-arrangement via the\n   --section-col-floor custom property), so a section's minimum scales with its\n   span. We intentionally do NOT use overflow-x:auto on the grid -- that would clip\n   inline dropdown menus -- and let the browser scroll the page instead. */\n.section-grid--wide {\n  grid-template-columns: repeat(12, minmax(var(--section-col-floor, 120px), 1fr));\n}\n\n/* Bootstrap field rows carry negative gutters that can spill past a bare\n   container; mirror a column's 15px padding on each side-by-side section so those\n   gutters are absorbed within the section instead of overflowing the grid. */\n.section-grid--wide .section-grid__item {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n/* On narrow screens, drop the grid and stack sections full-width in source order\n   so labels/inputs stay readable. */\n@media (max-width: 768px) {\n  .section-grid {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
